import script from "./TrainingContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingContent.vue?vue&type=script&setup=true&lang=js"

import "./TrainingContent.vue?vue&type=style&index=0&id=116eb418&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-116eb418"]])

export default __exports__